import { createStyles } from '@mantine/core'

type StylesParams = {
  bgColor: string
}

export default createStyles((theme, { bgColor }: StylesParams) => {
  return {
    root: {
      height: '100%',
      [theme.fn.smallerThan('sm')]: {
        backgroundColor: '#fff',
        paddingTop: 0,
      },
      [theme.fn.largerThan('sm')]: {
        backgroundColor: bgColor || theme.colors.neutral[0],
      },
    },
    wrapper: {},
    formFrame: {},
    bannerImg: {},
    container: {},
    modalBody: {},
  }
})
